export {
  Download as IconDownload,
  ExternalLink as IconExternalLink,
  Copy as IconCopy,
  Trash2 as IconTrash2,
  Pencil as IconPencil,
  CircleHelp as IconCircleHelp,
  Minus as IconMinus,
  Plus as IconPlus,
  X as IconX,
  Search as IconSearch,
  Eye as IconEye,
  EyeOff as IconEyeOff,
  MapPin as IconMapPin,
  ChevronDown as IconChevronDown,
  EllipsisVertical as IconEllipsisVertical,
  File as IconFile,
  Redo as IconRedo,
  Undo as IconUndo,
  ChevronRight as IconChevronRight,
  ChevronLeft as IconChevronLeft,
  Menu as IconMenu,
  ImagePlus as IconImagePlus,
  Printer as IconPrinter,
  Check as IconCheck,
  CircleAlert as IconCircleAlert,
  TriangleAlert as IconTriangleAlert,
  CircleCheck as IconCircleCheck,
  Info as IconInfo,

  type LucideIcon,
} from 'lucide-react';

//
//

export const IconAlert = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      style={{ transform: 'rotate(180deg)' }}
    >
      <line x1="12" x2="12" y1="8" y2="12" />
      <line x1="12" x2="12.01" y1="16" y2="16" />
    </svg>
  );
};
